;(function($, undefined){
    var rnn, log, maps, form;

    var addFormFieldLabels;
    var addFormCookieName;

    var browserSupportsFileReader = !!window.FileReader;

    function setAddFormCookie() {
        Cookies.set(addFormCookieName, "success", { path: "/" });
    }

    function getAddFormCookie() {
        return Cookies.get(addFormCookieName);
    }

    function clearAddFormCookie() {
        Cookies.remove(addFormCookieName);
    }

    function fireAddressChanged($target, address){
        var addressChangedEvent = $.Event('addresschanged');

        addressChangedEvent.address = address;

        addressChangedEvent.target = $target[0];

        $target.trigger(addressChangedEvent);
    }

    function resetLocationControls($form) {
        var fieldNames = ['street_address', 'locality', 'locality_id', 'latitude', 'longitude'];

        fieldNames.fastEach(function(fieldName){
            $form.find('[name=' + fieldName + ']').val('');
        });

        fireAddressChanged($form.find('[name=street_address]'), '');
    }

    function addressFieldChanged(event){
        var $target = $(event.target),
            $form = $target.closest('.mapArea'),
            $streetAddress = $form.find('[name=street_address]'),
            $locality = $form.find('[name=locality]'),
            streetAddress = $locality.val();

        $target.closest('.control-group').removeClass("error");

        if ($streetAddress.val()) {
            streetAddress = $streetAddress.val() + ', ' + streetAddress;
        }

        fireAddressChanged($target, streetAddress);
    }

    function addressChanged(event) {
        var address = event.address,
            location = event.location,
            $target = $(event.target),
            $form = $target.closest('.mapArea'),
            $streetAddress = $form.find('[name=street_address]'),
            $locality = $form.find('[name=locality]'),
            $localityId = $form.find('[name=locality_id]'),
            streetAddress = '',
            localityText = '';

        if (event.target === $streetAddress[0] || event.target === $locality[0]) {
            // We dont want to listen to our own events!
            return;
        }

        if (address.postCode) {
            if (address.locality) {
                if (address.postCode.indexOf(address.locality) === 0) {
                    localityText = address.postCode;
                } else {
                    localityText = address.locality + ', ' + address.postCode;
                }
            } else {
                localityText = address.postCode;
            }
        } else if (address.locality) {
            localityText = address.locality;
        }
        if (address.streetAddress) {
            streetAddress = address.streetAddress;
        }

        if (localityText || streetAddress) {

            $streetAddress.val(streetAddress);

            // When the locality text changes, clear the hidden Locality ID.
            // We can't easily determine the new value, so just lose it.
            if (localityText != $locality.val()) {
                $localityId.val('');
                $locality.val(localityText);
            }
        }
    }

    function locationChanged(event) {
        var $target = $(event.target),
            $form = $target.closest('.mapArea'),
            $latitude = $form.find('[name=latitude]'),
            $longitude = $form.find('[name=longitude]'),
            position = event.location;

        $latitude.val(position.latitude);
        $longitude.val(position.longitude);
    }

    function handleNoGeocodeResults(event) {
        $(event.target).closest(".control-group").addClass("error");
    }

    function submitForm(event) {
        var $target = $(event.target),
            $form = $target.closest('form'),
            isMultipart = ($form.attr('enctype') == 'multipart/form-data'),
            settings = $form.closest('[data-module]').data('module');

        function success(response) {
            console.log('success');
            if (!response.valid) {
                $form.find('.messages')
                    .append(forms.createErrorsAlert($form, response.errors)).end()
                    .find('button').button('reset');
            } else {
                setAddFormCookie();
                if (settings && settings.success) {
                    settings.success.call($form[0]);
                } else if (settings && settings.next) {
                    window.location = settings.next;
                } else {
                    window.location.reload();
                }
            }
        }

        function failure(error) {
            console.log('failure');
            log(error);
            rnn.modules.alert.show($form, {
                message: 'Unfortunately, a problem occured while attempting to post your notice. Please try again.',
                title: 'Could not post notice',
                type: 'error',
                prepend: true
            });
            $form.find('button:not(.minimise)').button('reset');
        }

        function submitViaAjax() {
            event.preventDefault();
            $form.ajaxSubmit({
                success: success,
                error: failure,
                dataType: 'json'
            });
        }

        function submitViaIframe() {
            var iframeId, $iframe;

            iframeId = new Date().getTime().toString();

            $form.attr('target', iframeId);

            $iframe = $($.el.iframe({'id': iframeId, 'name': iframeId, src: 'about:blank'}))
            .hide()
            .appendTo($form)
            .on('load', function (event) {
                var responseText, responseJSON;

                try {
                    responseText = this.contentWindow.document.body.innerText;
                    responseJSON = $.parseJSON(responseText);
                    $iframe.remove();
                    success(responseJSON);
                } catch (error) {
                    failure(error);
                }

            });
        }

        $form
        .find('button:not(.minimise,.close)')
            .button('loading')
        .end()
        .find('.alert-success')
            .hide()
        .end()
        .find('.alert-error')
            .hide(function(){
                $(this).remove();
            })
        .end()
        .find('.control-group.error')
            .removeClass('error')
        .end();

        if (!isMultipart || browserSupportsFileReader) {
            submitViaAjax();
        } else {
            submitViaIframe();
        }
    }

    function imageFieldChanged(event) {
        var $field, $form, $imagePicker, $preview, $previewImg,
            $previewText, $previewRemoveBtn, files, fileReader;

        $field = $(this);
        $form = $field.closest('form');
        $imagePicker = $form.find('.image-picker');
        $preview = $imagePicker.find('.preview');
        $previewImg = $preview.find('img');
        $previewText = $preview.find('p');
        $previewRemoveBtn = $preview.find('button');
        files = this.files;

        if ($previewRemoveBtn.length) {
            $previewRemoveBtn.remove();
        }

        $previewRemoveBtn = $($.el.button({'class':'close'}))
        .text('\u00D7')
        .appendTo($preview)
        .on('click', function () {
            $imagePicker.replaceWith($form.data('imagePickerTemplate').clone());
        });

        if (!browserSupportsFileReader) {
            $previewText.text($field.val().split('\\').pop().split('/').pop());
            return;
        }

        reader = new window.FileReader();

        reader.onload = function(event){
            $previewImg.attr('src', event.target.result);
        };

        reader.readAsDataURL(files[0]);
    }

    function initAddForm() {
        var $form, $description, $imagePicker, $street_address,
            $locality_id, $latitude, $longitude, $map;

        $form = $(this);
        $description = $form.find('[name=description]');
        $imagePicker = $form.find('.image-picker');
        $street_address = $form.find('[name=street_address]');
        $locality_id = $form.find('[name=locality_id]');
        $latitude = $form.find('[name=latitude]');
        $longitude = $form.find('[name=longitude]');
        $map = $form.find('.map');

        if (!!getAddFormCookie()) {
            $form
            .find('.alert-success')
            .show();
            clearAddFormCookie();
        }

        rnn.modules.user.get(function (user) {
            if (user.authenticated) {
                if ($form.is('.noticeAddFormStandard')) {
                    $form.addClass('state-minimal');
                } else {
                    $form.addClass('state-standard');
                }
                $form.removeClass('state-noauth');
            }
        });

        $form
        .one('focus', '[name=title],[name=type]', function () {
            $form
            .addClass('state-standard')
            .removeClass('state-minimal');
        })
        .on('click', '.enable-advanced-state', function (event) {
            event.preventDefault();
            $street_address.trigger('focus');
            $form
            .addClass('state-advanced')
            .removeClass('state-standard');
        })
        .on('click', '.enable-standard-state', function (event) {
            event.preventDefault();
            $form
            .addClass('state-standard')
            .removeClass('state-advanced');
            $description.trigger('focus');
            resetLocationControls($form);
        });

        // Save a clone of the image picker for refreshing later
        $form.data('imagePickerTemplate', $imagePicker.clone());

        maps.createLocationPickerMap($map);
    }

    function initForms() {

        // Static form setup
        $('.noticeAddForm').each(initAddForm);

        // Events for all kinds of '.noticeAddForm's
        $(document).on('change', '.noticeAddForm [name=locality]', addressFieldChanged)
            .on('keyup keypress', '.noticeAddForm [name=street_address],[name=locality]', _.debounce(addressFieldChanged, 300))
            .on('submit', '.noticeAddForm', submitForm)
            .on('change', '.noticeAddForm input[type="file"]', imageFieldChanged)
            .on('addresschanged', '.noticeAddForm', addressChanged)
            .on('locationchanged', '.noticeAddForm', locationChanged)
            .on('noresults', '.noticeAddForm', handleNoGeocodeResults);

        if($('#noticeDetailMap').length){
            maps.createDetailMap('noticeDetailMap');
        }

        if($('#noticeIndexMap').length){
            maps.createSearchResultsMap('noticeIndexMap');
        }
    }

    // Initialise Notices
    function initNotices() {

        forms = rnn.modules.forms;
        maps = rnn.modules.maps;

        initForms();
    }

    rnn = window.rnn;

    log = rnn.logging.log;

    addFormFieldLabels = {
        __all__: 'Location',
        type: 'Category',
        description: 'Your Notice'
    };

    addFormCookieName = 'noticesAddForm';

    rnn.modules.register('notices', {
        init: initNotices
    });

})(jQuery);
